import { loginAsRoute, loginRoute, resetPasswordRoute } from '@/features/auth/routes'
import { billingRoute } from '@/features/billing/routes'
import { bookingsRoutes } from '@/features/bookings/routes'
import { companyAccountRoute, companyDocumentsRoute, companyUsersRoute } from '@/features/company/routes'
import { integrationsRoute } from '@/features/integrations/routes'
import {
  notificationRoute,
  notificationSelectRoute,
  notificationSettingsRoute,
  notificationsRoute,
} from '@/features/notifications/routes'
import { quotesLayoutRoute, quotesRoute } from '@/features/quotes/routes'
import {
  reportCreateLayoutRoute,
  reportCreateRoute,
  reportEditLayoutRoute,
  reportEditRoute,
  reportsLayoutRoute,
  reportsRoute,
  reportWebsocketRoute,
} from '@/features/reports/routes'
import { settingsRoute } from '@/features/settings/routes'
import {
  overviewRoute,
  shipmentChargesRoute,
  shipmentContainersRoute,
  shipmentCustomsRoute,
  shipmentDetailsRoute,
  shipmentDocumentsRoute,
  shipmentPriceBreakdownRoute,
  shipmentRoute,
  shipmentsRoute,
} from '@/features/shipments/routes'
import { requiredActionsRoute } from '@/features/shipments/view/requiredActions/routes'
import { supportRoute } from '@/features/support/routes'

import { redirectShipV1Routes } from './redirectShipV1Routes'
import { rootRoute } from './root'

export const routeTree = rootRoute.addChildren([
  ...redirectShipV1Routes,
  overviewRoute,
  billingRoute,
  quotesLayoutRoute.addChildren([quotesRoute]),
  reportWebsocketRoute.addChildren([
    reportsLayoutRoute.addChildren([reportsRoute]),
    reportCreateLayoutRoute.addChildren([reportCreateRoute]),
    reportEditLayoutRoute.addChildren([reportEditRoute]),
  ]),
  shipmentsRoute,
  requiredActionsRoute,
  shipmentRoute.addChildren([
    shipmentDetailsRoute,
    shipmentContainersRoute,
    shipmentPriceBreakdownRoute,
    shipmentChargesRoute,
    shipmentCustomsRoute,
    shipmentDocumentsRoute,
  ]), // Not under layout component because it has multiple loaders
  loginRoute,
  loginAsRoute,
  resetPasswordRoute,
  companyUsersRoute,
  companyDocumentsRoute,
  companyAccountRoute,
  supportRoute,
  settingsRoute,
  integrationsRoute,
  notificationsRoute.addChildren([notificationSelectRoute, notificationRoute]),
  notificationSettingsRoute,
  ...bookingsRoutes,
])
